import { Component, ComponentClass, FC, Fragment } from "react";
import { connect } from "react-redux";
import { clearStudent } from "../actions/common/student";
import SectionsTemplate from "../components/templates/SectionsTemplate/index";
import { SectionProvider } from "../contexts/section";
import { WithRouterProps } from "../helpers/RouterHelper";
import { OperatorPrivilege } from "../interfaces/OperatorInterface";
import enhanceAuthenticatedPage, {
  AuthenticatedPageCallbacks,
  AuthenticatedPageProps,
  AuthenticateRouterProps,
} from "./enhanceAuthenticatedPage";

export interface SectionsPageProps
  extends WithRouterProps<AuthenticateRouterProps>,
    AuthenticatedPageProps,
    AuthenticatedPageCallbacks {
  clearStudent: typeof clearStudent;
}

interface PageInfoInterface {
  title: string;
}

const enhanceSectionsPage = (
  WrappedComponent: ComponentClass<any, any> | FC<any>,
  pageInfo: PageInfoInterface,
  requiredPrivileges?: OperatorPrivilege[],
) => {
  class SectionsPage extends Component<SectionsPageProps, unknown> {
    get studentFilter() {
      return this.props.studentFilterContext.findTagFilter({
        sectionId: this.props.currentSection?.data?.id || "",
      });
    }

    constructor(props: SectionsPageProps) {
      super(props);
    }

    componentDidMount() {
      /**
       * 生徒情報をパージ。校舎メニュー/生徒メニューの切り替えのタイミングで入退室ステータスを確実に取り直したいため。
       * (校舎メニュー生徒メニューを切り替えても、同じ生徒への遷移だと取り直ししていなかった)
       * セクションメニュー内を回遊するたびに実行されてしまうが、毎回リクエストが走るわけではないので許容できると判断
       */
      this.props.clearStudent();
    }

    render() {
      if (
        !this.props.currentSection.data ||
        !this.props.currentOperator ||
        !this.studentFilter ||
        this.props.params.sectionId !== this.props.currentSection.data.id
      ) {
        return null;
      }

      return (
        <Fragment>
          <SectionsTemplate pageInfo={{ title: pageInfo.title }}>
            <SectionProvider value={this.props.currentSection.data}>
              <WrappedComponent
                {...this.props}
                section={this.props.currentSection.data}
              />
            </SectionProvider>
          </SectionsTemplate>
        </Fragment>
      );
    }
  }
  return enhanceAuthenticatedPage(
    connect(null, mapDispatchToProps)(SectionsPage),
    requiredPrivileges,
  );
};
const mapDispatchToProps = {
  clearStudent,
};

export default enhanceSectionsPage;
